<style scoped lang="scss">
@import '$vars';
.container {
  flex-direction: column
}
figure {
  position: absolute;
  top: 0;
  text-align: center;
  img {
    width: 120%;
    margin-left: -10%;
    margin-top: -1em;
  }
}
.card {
  margin-top: 6em;
  background-color: $color-purple;
  color: white;
  border: 0;
  z-index: 0;
  header {
    border-bottom: 1px solid white
  }
  footer {
    margin: 1em 0
  }
}
h2 {
  font-family: $font1;
  font-size: 0.9rem;
  font-weight: 600;
}
</style>

<template>
   <main class="login-recovery">
      <form
        class="login-recovery__form"
        @submit.prevent="submit"
      >
        <header class="card-header login-recovery__header">
          <h2 class="text-center login-recovery__title">
            Recuperação de senha
          </h2>
        </header>

        <article class="card-body login-recovery__body">
          <dr-field
            v-for="(field, name) in form"
            :key="name"
            :validators.sync="$v.form[name]"
            :field.sync="field"
            :apiErrors.sync="apiErrors[field]"
          />

          <transition name="fade">
            <dr-captcha
              v-if="recoveryAttempts >= 1"
              ref="recovery-captcha"
              class="login__captcha"
              @on-check="isCaptchaSuccessful = true"
            />
          </transition>
        </article>

        <footer class="card-footer login-recovery__footer">
          <div class="column form-group">
            <dr-submit
              :disabled="recoveryAttempts >= 1 && !isCaptchaSuccessful"
              :sending="sending"
              text="Enviar"
              class="btn btn-primary col-12"
            />
          </div>

          <p class="text-center">
            <router-link
              to="/login"
              class="flex-center"
            >
              <br />
              Voltar para login
            </router-link>
          </p>
        </footer>
      </form>
  </main>
</template>

<script>
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import DrCaptcha from '@/components/form/recaptcha'
import { form, validations } from '@/data/formData/recovery'

export default {
  components: {
    drField,
    drSubmit,
    DrCaptcha
  },
  data () {
    return {
      form: form,
      email: null,
      recoveryAttempts: 0,
      isCaptchaSuccessful: false,
      sending: false,
      apiErrors: {
        password: []
      }
    }
  },
  validations: {
    form: validations
  },
  methods: {
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.sending = true
      this.fn_SHOW_PROGRESS()

      let data = {
        email: this.form.email.value
      }

      this.$http
        .post('/remember_password', { 'remember_password': data })
        .then((res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Acesse o link no email enviado para redefinir sua senha!',
            size: 'md',
            active: true
          })

          this.form.email.value = ''
          this.$router.replace({name: 'Login'})
        })
        .catch((err) => {
          const msg = (typeof err !== 'object')
            ? err
            : ('errors' in err)
              ? this.findErrorMessage(err.errors)
              : 'Ocorreu um erro.'

          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: msg,
            size: 'md',
            active: true
          })

          this.$v.$reset()

          this.recoveryAttempts++
          if (this.recoveryAttempts >= 1) {
            this.$refs['recovery-captcha'].resetRecaptcha()
            this.isCaptchaSuccessful = false
          }
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.sending = false
        })
    },
    findErrorMessage (object) {
      let errorMessage = null
      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }
      if (Array.isArray(object)) {
        object.forEach((element) => recursiveSearch(element))
      } else {
        recursiveSearch(object)
      }
      return errorMessage
    }
  }
}
</script>
